import { ApolloLink } from "./ApolloLink.js";
export var split = ApolloLink.split;
//# sourceMappingURL=split.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/split.js
// module id = ./node_modules/@apollo/client/link/core/split.js
// module chunks = 53 54